import { Component, computed, inject, input } from '@angular/core';
import { SelectUserGroupStore } from './select-user-group.store';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { MultiSelectInputComponent } from '../../../../kit/input/multi-select-input/multi-select-input.component';
import { FormGroup } from '@angular/forms';
import { InfiniteScrollStore } from '../../../../../modules/shared/store/common/infinite-scroll.store';
import { getGroupsFrag } from './select-user-group.query';
import { featureOn } from '../../../../../feature-flag';
import { CENTER_MANAGER_GROUP_NAME } from '@libs/types/src/user/constants/group.constants';
import { FilterInput } from '@it2go/data-grid';

@Component({
    selector: 'app-select-user-group',
    templateUrl: './select-user-group.component.html',
    styleUrls: ['./select-user-group.component.scss'],
    providers: [SelectUserGroupStore],
    imports: [
        MultiSelectInputComponent,
    ]
})
export class SelectUserGroupComponent {

    public readonly store = inject(SelectUserGroupStore);

    public disabled = input(false);
    public showLabel = input(true);
    public globalAcl = input(false);
    public id = input('groupIds');
    public form = input<FormGroup>(fb.group({
        groupIds: fb.control<number[]>([]),
    }));

    protected itemScroll = computed(() => {
        return new InfiniteScrollStore(
            this.store.api.getGroups,
            {
                filter: [
                    this.globalAcl() ? [
                        {
                            column: 'organizationId',
                            value: [''],
                            operator: 'EMPTY',
                        },
                    ] : [
                        {
                            column: 'organizationId',
                            value: [''],
                            operator: 'EMPTY',
                        },
                        {
                            column: 'organizationId',
                            value: [String(this.store.globalGlobalStore.organizationStore.selectedId())],
                            operator: 'EQ',
                        },
                    ],
                    [
                        {
                            column: 'isPrivate',
                            value: ['false'],
                            operator: 'EQ',
                        },
                    ],
                ],
            },
            true,
            getGroupsFrag,
            undefined,
            true,
        );
    });

}
